import { useGetDossierOverzicht } from "@/entities/dossier-overzicht";
import { OngewensteGebeurtenis, useGetOngewensteGebeurtenissen } from "@/entities/ongewenste-gebeurtenis";
import { OngewensteGebeurtenisOption } from "@/features/dossier-management/components/new-dossier/select-step.tsx";
import { formatDistanceToNowStrict } from "date-fns";
import { nl } from "date-fns/locale";
import { useMemo } from "react";

export type ExtendedOngewensteGebeurtenisOption = OngewensteGebeurtenisOption & {
    og: OngewensteGebeurtenis;
};

type AvailableOngewensteGebeurtenissenResult = {
    ongewensteGebeurtenissen: OngewensteGebeurtenis[];
    options: ExtendedOngewensteGebeurtenisOption[];
};

export function useGetAvailableOngewensteGebeurtenissen(): AvailableOngewensteGebeurtenissenResult {
    const { data: dossiers } = useGetDossierOverzicht();
    const { data: ongewensteGebeurtenissen } = useGetOngewensteGebeurtenissen({ forceRefetch: true });

    return useMemo(() => {
        if (!dossiers || !ongewensteGebeurtenissen) return { ongewensteGebeurtenissen: [], options: [] };
        const options = ongewensteGebeurtenissen
            .filter((item) => {
                const isExistingDossier = dossiers.some((dossier) => dossier.spoorwebNummer === item.nummer);
                return item.meldingStatus === "Open" && !isExistingDossier;
            })
            .map(
                (og): ExtendedOngewensteGebeurtenisOption => ({
                    og: og,
                    value: og.nummer,
                    label: og.nummer,
                    meldingtekst: og.meldingTekst,
                    spoorwebNr: og.nummer,
                    TIS: og.treinIncidentScenario?.code ?? "",
                    timeSinceEvent: og.startDatumTijd
                        ? formatDistanceToNowStrict(new Date(og.startDatumTijd), { addSuffix: true, locale: nl })
                        : undefined,
                })
            );

        // Return the full OG list for lookup by spoorwebNr; return filtered options for the dropdown
        return { ongewensteGebeurtenissen, options };
    }, [dossiers, ongewensteGebeurtenissen]);
}
